import isEqual from 'lodash/isEqual';
import { createProviderStore2 } from '@/common/store/createProviderStore';
import { POINT_TYPE } from '@/component/ShoppingCartIcon/model';
import { createWithEqualityFn } from 'zustand/traditional';
import { PageRowData, ServiceRule } from '../views/api';
import { webCurrency } from '@/common/const';
import { PriceObj } from '../views/content/components/PriceLine';

// 商详页跨组件获取信息
export const createDetailPageState = () =>
    createWithEqualityFn(
        (set: any) => ({
            store_id: Date.now(),
            cartSkuTag: null as POINT_TYPE,
            cartSkuCount: null as number | undefined, // 是否展示购物车，购物车入口红点数量
            immediateAvailableQuantity: 1, // 动态库存 伴随勾选规格而变化
            displayCommissionRate: '',
            // 达人佣金信息
            commissionInfo: {
                remainMilliseconds: 0,
                displayCommissionRate: '', // 佣金率
                // commission: '',
                displayCommissions: '',
                commissionSubsidy: 0, // 佣金补贴
                displayCommissionSubsidy: '',
                totalCommission: 0, // 总佣金（商家佣金+佣金补贴）
                displayTotalCommission: '',
            },
            // 关于券的信息 后面要改版 变成不容商详主接口里边返回 变成单独接口
            discountCoupon: [],
            refreshCartSkuCount: false, // 加购成功刷新红点数量
            // 首屏数据搬到Store
            pageRawData: {} as PageRowData,
            // B 端商详价格、腰封、秒杀的信息
            businessItemDetail: {},
            pageLoading: true,
            pageError: false,
            detailImageurls: [],
            purchaseQuantity: 1,
            specImageIndex: -1, // 规格图index
            swiperImageIndex: 0, // 商品图index（在swiper组件使用的index）
            setPurchaseQuantity: (val) => set(() => ({ purchaseQuantity: val })),
            currentSku: {},
            setCurrentSku: (val) => set(() => ({ currentSku: val })),
            fetchData: () => undefined,
            setFetchData: (val: Function) => set(() => ({ fetchData: val })),
            addressInfo: {},
            setAddressInfo: (val) => set(() => ({ addressInfo: val })),
            showVideoPhoto: true,
            setShowVideoPhoto: (val: boolean) => set(() => ({ showVideoPhoto: val })),
            activityBannerConfig: {},
            bottomAreaTipConfigLength: 0,
            // 商详页返回弹窗引导加购
            alertVisible: {
                specPupoup: false, // 多规格弹窗是否弹出
                visible: false,
                isOverTime: false,
                isClickedCart: false,
                isClickedBuy: false,
                isOverLastSpecTime: false,
                isOverLastOpenTime: false,
            },
            itemOnShelf: false,
            distributePlanOpen: false,
            merchant: {
                promoterType: 0,
            },
            setAlertVisible: (val) => set(() => ({ alertVisible: val })),
            productReco: {
                list: [],
                cursor: 0,
                hasNext: true,
                recoFirstLoading: true,
            },
            delivery: {
                logisticsType: 1,
                expressFeeType: 3,
                expressFee: -1,
                displayExpressFee: `${webCurrency}0,01`,
            } as ServiceRule,
            priceObj: {
                installmentPrice: {} as PriceObj,
                salePriceObj: {} as PriceObj,
                marketPriceObj: {} as PriceObj,
            },
            // 天降弹窗是否展示，用于多个弹窗的联动展示判断
            couponDialogState: '' as '' /* 初始值 */ | 'Openning' /* 弹窗打开中 */ | 'Closed' /* 弹窗被关闭 */ | 'NotNeed' /* 不需要弹窗 */,
            // 提单页动态运费券商详页利益点透出 弹窗是否展示，用于多个弹窗的联动展示判断
            couponDialog2State: '' as '' /* 初始值 */ | 'Openning' /* 弹窗打开中 */ | 'Closed' /* 弹窗被关闭 */ | 'NotNeed' /* 不需要弹窗 */,
            // 关闭弹窗2
            onCloseCoupon2Dialog() {
                set({ couponDialog2State: 'Closed' });
            },
            // 点击去购买按钮，从业务组件中set进来
            onBuyNow: null as (
                button_type?,
                options?: {
                    // 那先加个新字段is_shipping_coupon吧，如果是点了这一期优惠券上报1，否则为0
                    is_shipping_coupon: 1 | 0;
                },
            ) => void,
        }),
        isEqual,
    );

export type IDetailPageStata = ReturnType<typeof createDetailPageState>;

export type IDetailPageState = ReturnType<ReturnType<typeof createDetailPageState>['getState']>;

export const { ProviderComponent: DetailPageDataProvider, useStore: useDetailPageStore } =
    createProviderStore2<IDetailPageStata>(createDetailPageState);
